/** Clé de l'onglet de Réglages à ouvrir à la prochaine visite. */
export const CLE_ONGLET_REGLAGES = 'st_reglages_onglet';

/**
 * Ouvre Réglages sur un onglet donné.
 *
 * @param {(cible: string) => void} onNav navigation de l'application
 * @param {string} onglet identifiant de l'onglet (« banque », « documents »…)
 */
export function ouvreReglages(onNav, onglet) {
  try {
    sessionStorage.setItem(CLE_ONGLET_REGLAGES, onglet);
  } catch {
    // Stockage indisponible : Réglages s'ouvre sur son premier onglet.
  }
  if (onNav) onNav('reglages');
}

/**
 * Onglet de Réglages demandé par un autre écran.
 *
 * La lecture n'efface pas la demande : React peut appeler deux fois la valeur
 * initiale d'un état, et la seconde lecture doit trouver la même réponse.
 * L'écran l'oublie une fois affiché, par {@link oublieOngletReglages}.
 *
 * @param {string} parDefaut onglet ouvert sans demande
 * @returns {string} l'onglet à ouvrir
 */
export function ongletReglagesDemande(parDefaut) {
  try {
    return sessionStorage.getItem(CLE_ONGLET_REGLAGES) || parDefaut;
  } catch {
    // Stockage indisponible : l'onglet par défaut.
    return parDefaut;
  }
}

/** Oublie l'onglet demandé : la visite suivante de Réglages s'ouvre normalement. */
export function oublieOngletReglages() {
  try {
    sessionStorage.removeItem(CLE_ONGLET_REGLAGES);
  } catch {
    // Stockage indisponible : rien à oublier.
  }
}
